import React from "react";
import { AppBar } from "@mui/material";
import { Logo, GridContainer, Container } from "components";

const SimpleTopbar = (): JSX.Element => {
  return (
    <AppBar
      position="absolute"
      sx={{
        top: { xs: 16, md: 32 },
        background: "transparent",
        boxShadow: "none",
      }}
    >
      <GridContainer pb={0}>
        <Container>
          <Logo />
        </Container>
      </GridContainer>
    </AppBar>
  );
};

export default SimpleTopbar;
